/* global UserNotificationStore */

import {render} from 'react-dom';
import {Provider} from 'react-redux';

import {createStore} from '../utils/redux';

import reducer from './reducer';
import {addNotification, initialNotifications} from './actionCreators';

import UserNotifications from './components/UserNotifications';

const UserNotificationsNode = document.getElementById('user-notifications');
const CSRFMiddlewareTokenNode = UserNotificationsNode.getElementsByTagName('input')[0];
const CSRFMiddlewareToken = CSRFMiddlewareTokenNode.value;

const {messages, ...initial} = UserNotificationStore;

const store = createStore(reducer, 'Start');

store.dispatch(initialNotifications({...initial, CSRFMiddlewareToken}));

messages.forEach(({text, tags}) => store.dispatch(addNotification(text, tags)));

render(
    <Provider store={store}>
        <UserNotifications />
    </Provider>,
    UserNotificationsNode,
);
